var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalP3Move(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1224 55.3519L27.2023 26.0011L56.553 33.9211L43.5654 41.8288L43.2332 42.0311L43.0309 42.3633L35.1224 55.3519Z",
    stroke: "#FF5368",
    strokeWidth: 3.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4178 18.6385L37.6604 11.0017",
    stroke: "#FF5368",
    strokeWidth: 3.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1228 31.9334L12.4861 36.176",
    stroke: "#FF5368",
    strokeWidth: 3.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0748 17.0866L23.5215 8.16992",
    stroke: "#FF5368",
    strokeWidth: 3.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.571 23.5904L9.6543 22.0371",
    stroke: "#FF5368",
    strokeWidth: 3.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalP3Move);
export default __webpack_public_path__ + "static/media/Digital_P3_Move.9bb59f5d5d2fb8d905565085deed2f1c.svg";
export { ForwardRef as ReactComponent };